export default __webpack_public_path__ + "static/media/carousel-umbrella-faces.07b46b7e.png";